import { render } from "./footer-nav.vue?vue&type=template&id=6f3283c2"
import script from "./footer-nav.vue?vue&type=script&lang=js"
export * from "./footer-nav.vue?vue&type=script&lang=js"

import "./footer-nav.vue?vue&type=style&index=0&id=6f3283c2&lang=scss"
script.render = render

export default script